exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-download .title-wrap{border-top:2px solid rgba(0,0,0,.2);margin-bottom:70px;padding-top:100px}@media (max-width:768px){.card-download .title-wrap{padding-top:50px;margin-bottom:50px}}.card-download .title-wrap h1{text-align:center}.card-download .img-wrap img{width:100%}.card-download .download-wrap{margin-top:80px}@media (max-width:576px){.card-download .download-wrap{margin-top:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7851954","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Index/CardDownload.vue
// module id = 197
// module chunks = 0